import React, { useState } from 'react';
import { Offcanvas } from 'react-bootstrap';
import { FiChevronRight, FiArrowLeft } from 'react-icons/fi';
import { FaFacebookF, FaInstagram, FaPinterestP, FaYoutube } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import styles from './bodywon.module.css';
import ProductCard from './ProductCard';

const MobileMenu = ({ show, onHide, navLinks, onAddToCart }) => {
  const [level1Active, setLevel1Active] = useState(null);
  const [level2Active, setLevel2Active] = useState(null);

  const handleHide = () => {
    setLevel1Active(null);
    setLevel2Active(null);
    onHide();
  };

  const renderLevel1 = () => (
    <ul className={styles.mobileMenuList}>
      {navLinks.map(link => (
        <li key={link.name}>
          {link.megaMenu ? (
            <button onClick={() => setLevel1Active(link)} className={styles.mobileMenuLink}>
              {link.name} <FiChevronRight />
            </button>
          ) : (
            <a href={link.path} onClick={handleHide} className={styles.mobileMenuLink}>
              {link.name}
            </a>
          )}
        </li>
      ))}
    </ul>
  );

  const renderLevel2 = () => {
    if (!level1Active?.megaMenu) return null;
    return (
      <>
        <ul className={styles.mobileMenuList}>
          {level1Active.megaMenu.columns.map(column => (
            <li key={column.title}>
              <button onClick={() => setLevel2Active(column)} className={styles.mobileMenuLink}>
                {column.title} <FiChevronRight />
              </button>
            </li>
          ))}
        </ul>
        {level1Active.megaMenu.products && (
          <div className={styles.submenuProducts}>
            <h5 className={styles.submenuTitle}>TOP SELLERS</h5>
            {level1Active.megaMenu.products.map((prod) => (
              <div key={prod.id} className={styles.featureCardWrapper}>
                <ProductCard product={prod} onAddToCart={onAddToCart} />
              </div>
            ))}
          </div>
        )}
      </>
    );
  };

  const renderLevel3 = () => {
    if (!level2Active) return null;
    return (
      <ul className={styles.mobileMenuList}>
        {level2Active.links.map(link => (
          <li key={link.name}>
            <a href={link.path} onClick={handleHide} className={styles.mobileMenuLink}>
              {link.name} <FiChevronRight />
            </a>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <Offcanvas show={show} onHide={handleHide} placement="start" className={styles.mobileMenu}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          {level2Active ? (
            <div className={styles.submenuHeader}>
              <button onClick={() => setLevel2Active(null)} className={styles.backButton}><FiArrowLeft /></button>
              <span>{level2Active.title}</span>
            </div>
          ) : level1Active ? (
            <div className={styles.submenuHeader}>
              <button onClick={() => setLevel1Active(null)} className={styles.backButton}><FiArrowLeft /></button>
              <span>{level1Active.name}</span>
            </div>
          ) : (
            'Menu'
          )}
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        {level2Active ? renderLevel3() : level1Active ? renderLevel2() : renderLevel1()}

        {!level1Active && !level2Active && (
          <div className={styles.mobileMenuSocial}>
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaXTwitter /></a>
            <a href="#"><FaPinterestP /></a>
            <a href="#"><FaInstagram /></a>
            <a href="#"><FaYoutube /></a>
          </div>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default MobileMenu;
